export default "__VITE_ASSET__BwWPcYrG__"